import React from 'react';
import { GPH_COPY } from '../../services/gph/gphCopy';

// Chips iniciais de intenção — compactos e horizontais. Não é grid de dashboard.
export default function GphQuickIntents({ onSelect, disabled = false }) {
  return (
    <div className="gph-quick-intents" role="list" aria-label="Sugestões rápidas">
      {GPH_COPY.quickIntents.map((intent) => (
        <button
          key={intent.id}
          type="button"
          role="listitem"
          className="gph-chip"
          disabled={disabled}
          onClick={() => onSelect?.(intent.text)}
        >
          {intent.label}
        </button>
      ))}
    </div>
  );
}
